<script>

import { API_USER, API_USER_PAY } from '../../common/api'

export default {
  name: 'UserPay',
  props: ["user_id"],
  data () {
    return {
      userPayForm: {
        money: ''
      },
      rules: {
        money: [
          { required: true, message: '缴费金额不能为空', trigger: 'blur' }
        ],
      },
      user_obj: {
        id: 0,
        number: '',
        name: '',
        last_amount: '',
        now_amount: '',
        use_amount: '',
        water_price: '',
        balance: '',
      }
    }
  },
  created () {
    this.selectUser()
  },
  methods: {
    selectUser () {
      this.$http.GET(API_USER + '/' + this.user_id, null,
      res => {
        this.user_obj = res.result.data;
      }, err => {
        this.$message.error(err.msg)
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    pay (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = this.userPayForm;
          params.user_id = this.user_id;
          this.$http.POST(API_USER_PAY, params,
          res => {
            this.loading = false;
            this.$emit('paySuccess')
          }, err => {
            this.loading = false;
            this.$message.error(err.msg)
          })
        }
      })
    }
  }
}
</script>

<template>
  <div>
    <el-form ref="userPayForm" :model="userPayForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
      <el-form-item label="用户编号">
        <el-input v-model="user_obj.number" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input v-model="user_obj.name" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="上次表底">
        <el-input v-model="user_obj.last_amount" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="抄表数">
        <el-input v-model="user_obj.now_amount" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用水量">
        <el-input v-model="user_obj.use_amount" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="应缴纳费用">
        <el-input v-model="user_obj.water_price" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="账户余额">
        <el-input v-model="user_obj.balance" disabled class="rt-input form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="实际缴费" prop="money">
        <el-input type="number" v-model="userPayForm.money" placeholder="请输入缴费金额" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('userPayForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="pay('userPayForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/user/UserPay.vue